export type ApiResponseOwnerDetail = {
  id: number,
  name: string,
  phoneNumber: string,
}

export class OwnerDetail {
  id: number
  name: string
  phoneNumber: string

  constructor(apiResponseOwnerDetail: ApiResponseOwnerDetail) {
    this.id = apiResponseOwnerDetail.id;
    this.name = apiResponseOwnerDetail.name;
    this.phoneNumber = apiResponseOwnerDetail.phoneNumber;
  }
}
